import "./CompliancePipeline.css";

/**
 * Design-system data table for the approval views: a horizontally scrollable
 * .ds-table-wrap around a .ds-table, so every extracted norm/approval table
 * shares one look. `className` adds view-specific column sizing.
 */
export default function DataTable({ className = "", children }) {
  return (
    <div className="ds-table-wrap cp-table-wrap">
      <table className={`ds-table ${className}`.trim()}>{children}</table>
    </div>
  );
}
